export default __webpack_public_path__ + "static/media/login-step2.7bf80fc4.svg";